import { render, staticRenderFns } from "./3v3dir-icon.vue?vue&type=template&id=795a783e&scoped=true&"
import script from "./3v3dir-icon.vue?vue&type=script&lang=js&"
export * from "./3v3dir-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795a783e",
  null
  
)

export default component.exports